<div class="modal-header">
    <h4 *ngIf="headerText">
        {{ headerText }}
    </h4>
</div>
<div class="modal-body">
    <div>
        <label *ngIf="labelText" for="body-text">{{ labelText }}</label><br />
        <div id="body-text">
            {{ bodyText }}
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" 
            class="btn btn-text-primary" 
            (click)="closeModal()">{{ buttonText }}
    </button>
</div>